<div class="flex h-full flex-col items-center justify-center p-6.5">
    <div class="flex justify-center">
        <div class="flex flex-col items-center gap-1">
            <div class="relative">
                <span
                    class="malou-text-50--bold md:malou-text-28--bold text-color-text-title text-center font-passion-one uppercase md:leading-tight"
                    [innerHTML]="'ranking.event.modal.title' | translate"></span>
                <mat-icon
                    class="absolute -right-7 bottom-[40px] !h-10 !w-10 shrink-0 text-malou-pink md:!h-7 md:!w-7"
                    [svgIcon]="SvgIcon.SPARKLES"></mat-icon>
            </div>
            <span class="malou-text-22--semibold text-center text-malou-text-title">{{ restaurantName() }} </span>
            <span class="malou-text-16--semibold text-center text-malou-text">{{ restaurantAddress() }} </span>
        </div>
    </div>
    <div
        class="malou-text-200--bold relative"
        [ngClass]="{
            'text-malou-pink': totalScoreRating() === DiagnosticRating.BAD,
            'text-malou-yellow': totalScoreRating() === DiagnosticRating.AVERAGE,
            'text-malou-green': totalScoreRating() === DiagnosticRating.GOOD,
        }">
        {{ currentValue() }}
        @if (shouldShowCrown()) {
            <img
                class="absolute left-[-38px] top-[-10px] w-28"
                alt="crown"
                [ngClass]="{
                    'fade-in-animation': shouldShowCrown(),
                }"
                [src]="Illustration.CROWN | illustrationPathResolver" />
        }
    </div>
    <div class="w-1/2">
        <app-loader-progress
            [progress]="currentValue()"
            [showPercentage]="false"
            [diagnosticRating]="totalScoreRating()"></app-loader-progress>
    </div>
    <app-rating-chip class="mt-8 w-fit" [diagnosticRating]="totalScoreRating()"></app-rating-chip>
</div>
